module.exports = __webpack_public_path__ + "img/GK.319690c0.svg";